import React from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Bold from '../Bold';
import MarkingItem from '../MarkingItem';
import Topic from '../Topic';

const useStyles = makeStyles((theme) => ({
  textStyle: {
    fontWeight: 'bold',
    fontSize: 20,
    color: '#161D4B',
  },
  text: {
    textAlign: 'justify',
    fontSize: 15,
    marginTop: 0,
  },
  textMarginTop10: {
    textAlign: 'justify',
    fontSize: 15,
    marginTop: 10,
  },
}));

function ModalPrivacyPolice() {
  const classes = useStyles();

  return (
    <div style={{ paddingHorizontal: 15, paddingTop: 15 }}>
      <div style={{ flex: 2 }}>
        <Typography className={classes.textStyle}>
          POLÍTICA DE PRIVACIDADE
        </Typography>
      </div>
      <div style={{ flex: 1 }} />
      <Topic text="1. Informações gerais" />
      <Typography className={classes.text}>
        Ao acessar ou utilizar quaisquer dos serviços disponibilizados pela XMEI
        BRASIL SERVIÇOS S.A., sociedade anônima de capital fechado, inscrita no
        CNPJ sob o nº 32.765.502/0001-08, com sede na Avenida Copacabana, nº
        297, Quadra 145, Lote Area 3, Goiânia – Goiás, CEP 74.343-240, doravante
        denominado (“
        <Bold text="XMEI" />
        ”) por meio do site e do aplicativo XMEI (“
        <Bold text="Software" />
        ”), utilizando-se de qualquer meio de acesso, incluindo aparelhos
        móveis, celulares, tablets, computadores pessoais, navegadores de
        internet e demais meios de acesso que vierem a ser desenvolvidos, você
        (“
        <Bold text="Usuário" />
        ”), na qualidade de pessoa física ou jurídica, leu, entendeu, concorda e
        aceita (e tem a capacidade jurídica para tanto) as presentes cláusulas e
        condições, da presente política de privacidade (“
        <Bold
          text="Política de
          Privacidade"
        />
        ”), que versa sobre os serviços de assessoria fiscal prestado pela XMEI
        através do Software (“
        <Bold text="Serviços" />
        ”).
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A presente Política de Privacidade foi elaborada pela XMEI para os
        <Bold text=" Usuários" />
        possam compreender de forma simples como a XMEI utiliza, coleta, protege
        e lida com informações de todos os Usuários.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A política de privacidade da XMEI foi elaborada em conformidade com a
        legislação vigente, especialmente a Lei 12.965/2014 (uso da internet no
        Brasil), Lei 13.709/2018 (Lei Geral de Proteção de Dados) e demais
        legislações aplicáveis.
      </Typography>
      <Typography className={classes.text}>
        O objeto da XMEI é manter a relação com o Usuário o mais transparente
        possível. A XMEI quer que o Usuário se sinta seguro para que a XMEI
        possa ser uma ferramenta para auxiliar o dia-a-dia da sua empresa, sem
        preocupações sobre os dados que serão ali inseridos e processados.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Lembrando que a presente Política de Privacidade é parte integrante do
        Termo de Uso, devendo, portanto, ser lida em conjunto com tal termo,
        antes de qualquer acesso ou utilização dos Serviços da XMEI.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Os tipos de informações (“
        <Bold text="Informações" />
        ”) que a XMEI coleta para fornecer, aprimorar e proteger seus Serviços
        são: Informações de conta: nós coletamos e associamos a conta do Usuário
        na XMEI, além das informações deste de login, informações nome, endereço
        de e-mail, número de telefone, endereço, certificação digital,
        informações de pagamento (“
        <Bold text="Informações de Conta" />
        ”).
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Informações dos serviços: para utilizar os Serviços da XMEI de maneira
        satisfatória, o Usuário processa e nos transmite seus arquivos e
        informações, incluindo, mas não se limitando a informações de receitas
        (faturamentos) e despesas (“
        <Bold text="Informações dos Serviços" />
        ”).
      </Typography>
      <Typography className={classes.textMarginTop10}>
        Informações de uso: para manter os Serviços sempre atualizados e
        melhorar sua qualidade, a XMEI coleta informações sobre os dispositivos
        que o Usuário utiliza para acessar os Serviços (“
        <Bold text="Cookies" />
        ”). Isso inclui, mas não se limita, a endereços IP, tipo de navegador e
        dispositivo que o Usuário utiliza, páginas da web que visitou antes de
        chegar ao site da XMEI, links que foram clicados e identificadores
        associados aos seus dispositivos (“
        <Bold text="Informações de Uso" />
        ”).
      </Typography>
      <Topic text="2. Direitos de Usuário" />
      <Typography className={classes.text}>
        A XMEI se compromete a garantir aos Usuários os direitos conferidos
        pelas normas vigentes. Os Usuários poderão exercer seus direitos por
        meio de comunicação escrita enviada ao aplicativo, informando seus dados
        completos, o direito que pretende exercer junto à XMEI e a documentação
        para demonstrar ou justificar seu direito, data e assinatura. O pedido
        deve ser enviado ao e-mail: contato@xmeibrasil.com.br. O usuário será
        informado em caso de retificação ou eliminação de seus dados
      </Typography>
      <Topic text="3. Dever do Usuário de não fornecer dados de terceiros" />
      <Typography className={classes.text}>
        Durante a utilização do Software da XMEI o Usuário se compromete a
        fornecer somente seus dados pessoais, nunca de terceiros, a fim de
        resguardar e proteger os direitos destes.
      </Typography>
      <Topic text="4. Divulgação das Informações" />
      <Typography className={classes.text}>
        O Usuário ao aceitar utilizar o Software (APP), além de aceitar
        integralmente este Termo de Privacidade, também consente, livre e
        expressamente, que a XMEI colete, use, armazene e faça o tratamento de
        suas Informações de Conta e Informações de Serviço, as quais são
        essenciais para que os Serviços sejam prestados em sua integralidade.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A XMEI fica excluída, a qualquer tempo e dentro da razoabilidade
        necessária, da obrigatoriedade de confidencialidade ora estabelecida na
        eventual ocorrência de: (
        <Bold text="i" />
        ) cumprimento da legislação vigente; (
        <Bold text="ii" />
        ) detectar, prevenir fraudes, abuso ou demais atividades ilegais ou em
        desacordo com a Presente Politica de Privacidade ou Termo de Uso; (
        <Bold text="iii" />
        ) proteção de direito de propriedade da XMEI; (
        <Bold text="iv" />) requerimento de autoridade governamental ou de
        medida judicial.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O Usuário consente ainda que a XMEI utilize as Informações de Uso apenas
        para controlar a audiência e a navegação em seu Software (APP) e
        possibilitar a identificação de serviços segmentados e personalizados ao
        perfil do Usuário. A XMEI garante que estas informações coletadas por
        meio das Informações de Uso são estatísticas e não pessoais, bem como
        que não serão utilizadas para propósitos diversos dos expressamente
        previstos neste Termo de Privacidade e no Termo de Uso, comprometendo-se
        a adotar todas as medidas necessárias a fim de evitar o acesso e o uso
        de tais informações por quaisquer terceiros, sem a devida autorização.
      </Typography>
      <Bold text="A XMEI poderá utilizar as informações do Usuário para os seguintes usos especificados abaixo, mas não se limitando:" />
      <MarkingItem
        marking=""
        text="Auxiliá-lo a acessar suas informações de maneira eficiente após acessar os Serviços;"
      />
      <MarkingItem
        marking=""
        text="Registrar informações de acesso para que o Usuário não tenha que completá-las toda vez que se conectar ao Software (APP);"
      />
      <MarkingItem
        marking=""
        text="Fornecer conteúdo personalizado e informação direcionada para os Usuários, incluindo, mas não se limitando a, propagandas ou publicidades;"
      />
      <MarkingItem
        marking=""
        text="Melhorar, testar e monitorar a eficiência dos Serviços da XMEI;"
      />
      <MarkingItem
        marking=""
        text="Desenvolver e testar novos produtos e ferramentas aos Serviços da XMEI;"
      />
      <MarkingItem
        marking=""
        text="Monitorar informações relevantes para a XMEI, tais como o número total de visitantes, tráfego e padrões demográficos;"
      />
      <MarkingItem
        marking=""
        text="Diagnosticar e arrumar eventuais problemas no sistema da XMEI;"
      />
      <MarkingItem
        marking=""
        text="Atualizar automaticamente o Software (APP) dos Serviços prestados pela XMEI;"
      />
      <Typography className={classes.textMarginTop10}>
        Ao recusar o acesso aos Cookies e/ou demais monitoramentos aplicáveis
        para as Informações de Uso, o Usuário impede que a XMEI disponibilize
        seus Serviços da melhor e mais completa forma possível para o Usuário.
      </Typography>
      <Bold text="A XMEI poderá compartilhar as informações dos usuários com:" />
      <MarkingItem
        marking=""
        text="Terceiros que auxiliem a XEMEI a prover os Serviços por ela prestados, os quais terão acesso às Informações razoavelmente necessários para o provimento dos Serviços (parcerias comerciais)."
      />
      <MarkingItem
        marking=""
        text="No caso dos planos gratuitos, onde não há pagamento dos usuários pelo serviço prestado pela XMEI, esta poderá compartilhar informações dos Usuários com terceiros responsáveis por publicidades e propagandas veiculadas por meio/nos Serviços, considerando que tais Informações serão úteis para incluir publicidade e propaganda dirigida e customizada especialmente para o interesse do Usuário."
      />
      <Bold text="Mudança de controle societário:" />
      <Typography className={classes.text}>
        O Usuário consente livre e expressamente que suas informações poderão
        ser transferidas a terceiros em decorrência da venda, aquisição, fusão,
        reorganização societária ou qualquer outra mudança no controle
        societário ou acionário da XMEI, sem que haja remuneração ou pagamento
        algum ao Usuário, mantida a presente política de privacidade.
      </Typography>
      <Topic text="5. Armazenamento de informações" />
      <Typography className={classes.text}>
        A XMEI e sua equipe envidarão seus melhores esforços para guardar todas
        as Informações do Usuário com os maiores critérios de segurança
        possíveis, tomando medidas técnicas e organizativas para garantir a
        preservação da identidade do Usuário. Não obstante, apesar de todos os
        esforços da XMEI, o Usuário deve ter conhecimento e concordar que
        a internet (e, por consequência os Serviços) está continuamente exposta
        a terceiros, usuários ou não, hackers¸ softwares mal intencionados e
        similares, estando o serviço sujeito a diversas brechas de segurança e
        que, portanto, o compartilhamento e inserção de Informações pelo Usuário
        nos Serviços ou por meio dos Serviços podem não ser totalmente seguros,
        portanto, o Usuário assume o risco de utilização e acesso dos/aos
        serviços, de acordo com o Termo de Uso.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        O Usuário é responsável exclusivo por seu nome de usuário, endereço de
        e-mail de acesso e senha, não devendo fornecê-los a ninguém, mantendo-os
        em segredo, para prevenir eventuais acessos indevidos ao seu perfil e
        Informações.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A XMEI vai reter as Informações armazenadas somente enquanto forem
        necessárias para a satisfatória execução dos Serviços. Entretanto, o
        Usuário deve ficar atento as seguintes situações: (
        <Bold text="i" />
        ) pode haver alguma latência em apagar essas Informações de servidores
        da XMEI e armazenamento de reserva; e (
        <Bold text="ii" />) a XMEI poderá reter essas Informações, se
        necessário, para sua segurança, seja para cumprir com as suas obrigações
        legais, resolver litígios, ou qualquer outra situação em que a XMEI
        julgue necessário o armazenamento dos dados.
      </Typography>
      <Topic text="6. Publicidade" />
      <Typography className={classes.text}>
        A XMEI não é responsável por qualquer site ou serviços de terceiros
        disponibilizados em/por meio do Software, conforme os Termos de Uso.
        Sendo assim, os termos desta Política de Privacidade se aplicam,
        estritamente, aos Serviços disponibilizados pela XMEI.
      </Typography>
      <Topic text="7. Disposições finais" />
      <Typography className={classes.text}>
        Ao acessar os Serviços, por qualquer forma ou meio, ou clicar “Sign In”
        ou “aceite” ou “Registrar-se” ou “Logar” ou “Entrar” ou “Entre com sua
        conta”, o Usuário concorda, consente e adere à presente Política de
        Privacidade ao Termo de Uso da XMEI, em caráter irrevogável e
        irretratável e obriga não somente as partes, mas também seus sucessores
        e cessionários, a qualquer título.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A XMEI se reserva o direito de modificar, a qualquer momento o software,
        especialmente para adaptá-las às evoluções do aplicativo, seja pela
        disponibilidade de novas funcionalidades, seja pela supressão ou
        modificação daquelas já existentes.
      </Typography>
      <Typography className={classes.textMarginTop10}>
        A XMEI ainda reserva-se o direito de alterar a presente Política de
        Privacidade, em decorrência de eventual atualização normativa, momento
        em que disponibilizará ao Usuário a versão atualizada em seu Software
        (APP).
      </Typography>
      <Topic text="8. Do direito aplicável ao foro" />
      <Typography className={classes.text}>
        Por fim, caso tenhamos algum problema, a presente Política de
        Privacidade será interpretada segundo a legislação brasileira, sendo
        eleito o Foro da Comarca de Goiânia, Estado de Goiás, para dirimir
        qualquer litígio, questão ou dúvida superveniente, com expressa renúncia
        de qualquer outro, por mais privilegiado que seja.
      </Typography>
    </div>
  );
}

export default ModalPrivacyPolice;
